<template>
  <div
    :class="disabled && 'dr-switch--disabled'"
    class="dr-switch"
  >
    <div class="dr-switch__wrapper">
      <input
        :checked="value"
        :id="`dr-switch-checkbox-${id}`"
        :disabled="disabled"
        type="checkbox"
        class="dr-switch__checkbox"
        @change="(event) => {
          $emit('input', event.target.checked);
          $emit('change');
        }"
      >

      <label
        :for="`dr-switch-checkbox-${id}`"
        class="dr-switch__switch"
      />
    </div>

    <span class="dr-switch__label">
      <template v-if="labelChecked && value">
        {{ labelChecked }}
      </template>

      <template v-if="labelUnchecked && !value">
        {{ labelUnchecked }}
      </template>
    </span>
  </div>
</template>

<script>
export default {
  name: 'DrSwitch',

  props: {
    id: {
      type: [String, Number],
      required: false,
      default: () => 'switch'
    },

    value: {
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },

    labelChecked: {
      type: String,
      required: false
    },

    labelUnchecked: {
      type: String,
      required: false
    }
  }
}
</script>
